/**
 * Team-lookup helpers.
 *
 * Opta encodes each team's role in the fixture via the `position` field on
 * `matchInfo.contestant`. These helpers wrap that lookup so callers never have
 * to know the field name.
 */

/** @typedef {import('./types').Match} Match */
/** @typedef {import('./types').Contestant} Contestant */

/**
 * Find the contestant whose `position` matches the requested side.
 *
 * @param {Match} [match]
 * @param {'home' | 'away'} position
 * @returns {Contestant | undefined}
 */
const getTeamByPosition = (match, position) =>
  match?.matchInfo?.contestant?.find((c) => c.position === position);

/**
 * The home team for a given match, or `undefined` if unavailable.
 *
 * @param {Match} [match]
 * @returns {Contestant | undefined}
 */
export const getHomeTeam = (match) => getTeamByPosition(match, 'home');

/**
 * The away team for a given match, or `undefined` if unavailable.
 *
 * @param {Match} [match]
 * @returns {Contestant | undefined}
 */
export const getAwayTeam = (match) => getTeamByPosition(match, 'away');
